<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="健康证明">
              <FileUploader :fileList="formData.jiankangpics" accept=".pdf" :limit="1"></FileUploader>
              <div class="form-label-desc">上传健康证明</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="保险投保单">
              <FileUploader :fileList="formData.baodanpics" :limit="1"></FileUploader>
              <div class="form-label-desc">上传保险投保单</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="自愿参赛责任书">
              <FileUploader :fileList="formData.zerenshupics" :limit="1"></FileUploader>
              <div class="form-label-desc">上传自愿参赛责任书</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定提交
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue'; 

    import {
      Cell,
      Field,
      Area,
      Form,
      Divider,
      CellGroup,
      RadioGroup,
      Radio,
      ActionSheet,
      Icon,
      Toast,
      Popup,
      Picker,
      Sidebar,
      SidebarItem,
      Tag,
      Stepper,
      Switch,
      Button,
      Dialog
    } from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyBeizhu',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    }
                },
                formData:{
                  zerenshupics:[],
                  baodanpics:[],
                  jiankangpics:[],
                }
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },

          submitForm(formName) {
            const that = this;
            // 拿到地区的 省市区名称
            // that.formData["area"] = that.formData.areas[2];

            console.log(that.formData, that.$refs[formName])
            that.$refs[formName].validate((valid) => {
              if (valid) {
                that.$api.post('/api/isai/filesave',{
                  id : that.formData.id,
                  jiankangpics : that.formData.jiankangpics,
                  zerenshupics : that.formData.zerenshupics,
                  baodanpics : that.formData.baodanpics,
                },(res) => {
                  that.saveLoading = false;

                  that.$message.success('保存成功');

                  setTimeout(function () {
                    rbLink({
                      name:'ISaiApplyDetail',
                      query:{
                        id: that.row.id
                      }
                    },'back')
                  },100);

                }, (res) => {
                  that.$message.error(res.msg);
                  that.saveLoading = false;
                })
              } else {
                console.log("error submit!!");
                return false;
              }
            });
          },
          resetForm(formName) {
            this.$refs[formName].resetFields();
          },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/isai/beizhusave',{
                    id : that.formData.id,
                  jiankangpics : that.formData.jiankangpics,
                  zerenshupics : that.formData.zerenshupics,
                  baodanpics : that.formData.baodanpics,
                },(res) => {
                    that.saveLoading = false;

                    Toast('保存成功');

                    setTimeout(function () {
                        rbLink({
                            name:'ISaiApplyDetail',
                            query:{
                                id: that.row.id
                            }
                        },'back')
                    },100);

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/filedetail', {
                    id:that.row.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },



        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFile.vue?caf883c2